import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const CarePlanTemplatesPage = () => {
  const columns = [
    { key: 'name', label: 'Template Name' },
    { key: 'discipline', label: 'Discipline' },
    { key: 'diagnosis', label: 'Primary Diagnosis' },
    { key: 'goals', label: '# of Goals' },
    { key: 'active', label: 'Active' },
  ];

  const formFields = [
    { key: 'name', label: 'Template Name', type: 'text', required: true },
    { key: 'discipline', label: 'Discipline', type: 'select', required: true, options: [
      { value: 'RN', label: 'Registered Nurse' },
      { value: 'PT', label: 'Physical Therapy' },
      { value: 'OT', label: 'Occupational Therapy' },
      { value: 'SLP', label: 'Speech Therapy' },
      { value: 'MSW', label: 'Medical Social Work' },
      { value: 'HHA', label: 'Home Health Aide' },
    ]},
    { key: 'diagnosis', label: 'Primary Diagnosis', type: 'text', required: true },
    { key: 'goals', label: 'Number of Goals', type: 'number', required: false },
    { key: 'description', label: 'Description', type: 'textarea', required: false, fullWidth: true },
    { key: 'active', label: 'Active', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]}
  ];

  const initialData = [
    { id: '1', name: 'CHF Management', discipline: 'RN', diagnosis: 'Heart Failure', goals: '5', active: 'Yes' },
    { id: '2', name: 'COPD Care', discipline: 'RN', diagnosis: 'COPD', goals: '4', active: 'Yes' },
    { id: '3', name: 'Diabetes Management', discipline: 'RN', diagnosis: 'Diabetes Mellitus', goals: '6', active: 'Yes' },
    { id: '4', name: 'Post-Hip Replacement', discipline: 'PT', diagnosis: 'Hip Replacement', goals: '5', active: 'Yes' },
    { id: '5', name: 'Post-Knee Replacement', discipline: 'PT', diagnosis: 'Knee Replacement', goals: '5', active: 'Yes' },
    { id: '6', name: 'Stroke Rehab - ADL', discipline: 'OT', diagnosis: 'CVA', goals: '6', active: 'Yes' },
    { id: '7', name: 'Dysphagia Management', discipline: 'SLP', diagnosis: 'Dysphagia', goals: '3', active: 'Yes' },
    { id: '8', name: 'Wound Care Protocol', discipline: 'RN', diagnosis: 'Wound Care', goals: '4', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Care Plan Templates"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Template"
      formFields={formFields}
      apiEndpoint="/setup/care-plan-templates"
    />
  );
};

export default CarePlanTemplatesPage;
